function initBundleCarousel(root) {
  const slider = root.querySelector('.bundle-carousel__slider');
  if (!slider) return;

  const slides = slider.querySelectorAll('.bundle-carousel__slide');
  const prevBtn = root.querySelector('.bundle-carousel__btn--prev');
  const nextBtn = root.querySelector('.bundle-carousel__btn--next');
  const dotsContainer = root.querySelector('.bundle-carousel__dots');

  if (!slides.length) return;

  let currentIndex = 0;
  let isTransitioning = false;
  let isInView = true; // Track if carousel is in viewport

  // AUTOPLAY - Get speed from data attribute
  let autoPlayInterval = null;
  const AUTO_PLAY_DELAY = parseInt(slider.dataset.autoplaySpeed) || 3000;

  // Update slider height to match active slide
  function updateSliderHeight() {
    const activeSlide = slides[currentIndex];
    if (activeSlide) {
      const height = activeSlide.offsetHeight;
      slider.style.height = height + 'px';
    }
  }

  function stopAutoplay() {
    if (autoPlayInterval) {
      clearInterval(autoPlayInterval);
      autoPlayInterval = null;
    }
  }

  function startAutoplay() {
    if (slides.length <= 1) return;
    // Only start autoplay if carousel is in view
    if (!isInView) return;
    
    stopAutoplay();
    autoPlayInterval = setInterval(() => {
      nextSlide();
    }, AUTO_PLAY_DELAY);
  }

  function resetAutoplay() {
    stopAutoplay();
    startAutoplay();
  }

  function updateDots() {
    if (!dotsContainer) return;
    const dots = dotsContainer.querySelectorAll('.bundle-carousel__dot');
    dots.forEach((dot, i) => dot.classList.toggle('active', i === currentIndex));
  }

  function goToSlide(index) {
    if (isTransitioning || index === currentIndex) return;
    
    isTransitioning = true;
    
    slides[currentIndex].classList.remove('active');
    currentIndex = index;
    slides[currentIndex].classList.add('active');
    updateDots();
    
    // Update height smoothly
    updateSliderHeight();
    
    // Reset transition lock after animation completes
    setTimeout(() => {
      isTransitioning = false;
    }, 600); // Match CSS transition duration
  }

  function nextSlide() {
    const next = (currentIndex + 1) % slides.length;
    goToSlide(next);
  }

  function prevSlide() {
    const prev = (currentIndex - 1 + slides.length) % slides.length;
    goToSlide(prev);
  }

  // Init first slide
  slides.forEach(s => s.classList.remove('active'));
  slides[0].classList.add('active');
  
  // Set initial height
  setTimeout(() => {
    updateSliderHeight();
  }, 100);

  // Build dots (only if there are multiple slides)
  if (dotsContainer && slides.length > 1) {
    dotsContainer.innerHTML = '';
    slides.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.className = 'bundle-carousel__dot';
      dot.type = 'button';
      dot.setAttribute('aria-label', `Go to bundle ${i + 1}`);
      if (i === 0) dot.classList.add('active');
      dot.addEventListener('click', () => {
        goToSlide(i);
        resetAutoplay();
      });
      dotsContainer.appendChild(dot);
    });
  }

  // Prev / Next (only if controls exist)
  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      prevSlide();
      resetAutoplay();
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      nextSlide();
      resetAutoplay();
    });
  }

  // Pause on hover
  slider.addEventListener('mouseenter', stopAutoplay);
  slider.addEventListener('mouseleave', startAutoplay);

  // Accordion
  const accordionHeaders = root.querySelectorAll('.accordion-header');
  accordionHeaders.forEach(header => {
    header.addEventListener('click', function() {
      const item = this.closest('.accordion-item');
      if (!item) return;

      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      const slide = this.closest('.bundle-carousel__slide');

      if (slide) {
        slide.querySelectorAll('.accordion-item').forEach(otherItem => {
          if (otherItem !== item) {
            otherItem.classList.remove('active');
            const otherHeader = otherItem.querySelector('.accordion-header');
            if (otherHeader) otherHeader.setAttribute('aria-expanded', 'false');
          }
        });
      }

      item.classList.toggle('active');
      this.setAttribute('aria-expanded', String(!isExpanded));
      
      // Update slider height when accordion opens/closes
      setTimeout(() => {
        updateSliderHeight();
      }, 50);
      
      resetAutoplay();
    });
  });

  // Keyboard nav
  root.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft') {
      prevSlide();
      resetAutoplay();
    }
    if (e.key === 'ArrowRight') {
      nextSlide();
      resetAutoplay();
    }
  });

  // Add to cart forms
  const addToCartForms = root.querySelectorAll('.bundle-add-to-cart-form');
  addToCartForms.forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const formData = new FormData(this);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(r => r.json())
      .then(() => { window.location.href = '/cart'; })
      .catch(err => console.error('Error adding to cart:', err));
    });
  });

  // Update height on window resize
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      updateSliderHeight();
    }, 250);
  });

  // NEW: Intersection Observer to pause autoplay when out of view
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.25 // At least 25% of the carousel must be visible
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      isInView = entry.isIntersecting;
      
      if (isInView) {
        // Carousel is in view, start autoplay
        startAutoplay();
      } else {
        // Carousel is out of view, stop autoplay
        stopAutoplay();
      }
    });
  }, observerOptions);

  // Observe the carousel section
  observer.observe(root);

  // Start autoplay initially (only if in view)
  startAutoplay();
}

function initAll() {
  document.querySelectorAll('.section-bundle-carousel').forEach(sectionRoot => {
    initBundleCarousel(sectionRoot);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAll);
} else {
  initAll();
}

document.addEventListener('shopify:section:load', function(e) {
  if (!e || !e.target) return;
  const sectionRoot = e.target.querySelector('.section-bundle-carousel') || e.target;
  if (sectionRoot && sectionRoot.classList.contains('section-bundle-carousel')) {
    initBundleCarousel(sectionRoot);
  }
});